var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconMetamask(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.8147 1L13.4346 7.93873L15.1835 3.8483L22.8147 1Z",
    fill: "#E17726",
    stroke: "#E17726",
    strokeWidth: 0.178465,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.18514 1L10.4796 7.99584L8.81631 3.85544L1.18514 1ZM19.4386 17.0833L16.94 20.8953L22.2869 22.3659L23.8145 17.1689L19.4386 17.0833ZM0.192871 17.1689L1.71339 22.3659L7.04594 20.8953L4.5617 17.0833L0.192871 17.1689Z",
    fill: "#E27625",
    stroke: "#E27625",
    strokeWidth: 0.178465,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.76022 10.6438L5.27539 12.8853L10.558 13.128L10.3866 7.43857L6.76022 10.6509V10.6438ZM17.2397 10.6509L13.5562 7.36719L13.4348 13.128L18.7174 12.8853L17.2397 10.6509ZM7.04577 20.8949L10.251 19.3529L7.4955 17.2113L7.04577 20.8949ZM13.7561 19.3458L16.9399 20.8949L16.5116 17.2042L13.7561 19.3458Z",
    fill: "#E27625",
    stroke: "#E27625",
    strokeWidth: 0.178465,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.94 20.8955L13.7562 19.3535L14.0132 21.4237L13.9846 22.3018L16.94 20.8955ZM7.0459 20.8955L10.0156 22.3018L9.99414 21.4237L10.2511 19.3535L7.0459 20.8955Z",
    fill: "#D5BFB2",
    stroke: "#D5BFB2",
    strokeWidth: 0.178465,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0656 15.834L7.42432 15.063L9.29463 14.2064L10.0727 15.834H10.0656ZM13.9276 15.834L14.7128 14.1992L16.5903 15.0559L13.9276 15.8411V15.834Z",
    fill: "#233447",
    stroke: "#233447",
    strokeWidth: 0.178465,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M7.04576 20.8953L7.50977 17.0832L4.56152 17.1689L7.04576 20.8953ZM16.4901 17.0832L16.9399 20.8953L19.4384 17.1689L16.4901 17.0832ZM18.7245 12.8857L13.442 13.1285L13.9274 15.8411L14.7126 14.1992L16.5901 15.0559L18.7245 12.8857ZM7.42411 15.063L9.29442 14.2064L10.0725 15.834L10.5651 13.1213L5.28252 12.8857L7.42411 15.063Z",
    fill: "#CC6228",
    stroke: "#CC6228",
    strokeWidth: 0.178465,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M5.28271 12.8857L7.49568 17.2046L7.4243 15.063L5.28271 12.8857ZM16.5903 15.063L16.5046 17.2046L18.7176 12.8857L16.5903 15.063ZM10.5653 13.1285L10.0656 15.8411L10.6938 19.0392L10.8366 14.8203L10.5653 13.1285ZM13.435 13.1285L13.178 14.8132L13.3065 19.0392L13.9276 15.834L13.435 13.1213V13.1285Z",
    fill: "#E27525",
    stroke: "#E27525",
    strokeWidth: 0.178465,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9274 15.8344L13.3063 19.0397L13.7561 19.3538L16.5044 17.2122L16.5901 15.0635L13.9274 15.8344ZM7.42413 15.0635L7.49552 17.2051L10.251 19.3466L10.6936 19.0397L10.0726 15.8344L7.41699 15.0635H7.42413Z",
    fill: "#F5841F",
    stroke: "#F5841F",
    strokeWidth: 0.178465,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9918 22.3018L14.0132 21.4238L13.7705 21.2239H10.2297L9.99414 21.4238L10.0156 22.3018L7.0459 20.8955L8.08814 21.7521L10.194 23.2013H13.799L15.9121 21.745L16.94 20.8955L13.9846 22.3018H13.9918Z",
    fill: "#C0AC9D",
    stroke: "#C0AC9D",
    strokeWidth: 0.178465,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7562 19.346L13.3065 19.0391H10.6937L10.2511 19.3532L9.99414 21.4234L10.2297 21.2235H13.7705L14.0132 21.4234L13.7562 19.3532V19.346Z",
    fill: "#161616",
    stroke: "#161616",
    strokeWidth: 0.178465,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M23.2148 8.38846L24 4.5693L22.815 1L13.749 7.71029L17.2397 10.6443L22.1654 12.0791L23.2504 10.8156L22.7793 10.4729L23.5289 9.78763L22.9578 9.34503L23.7073 8.77395L23.2076 8.38846H23.2148ZM0 4.56217L0.799524 8.38846L0.285544 8.76681L1.04938 9.3379L0.478287 9.78763L1.2207 10.4729L0.749554 10.8156L1.83462 12.0791L6.76026 10.6514L10.251 7.70315L1.18501 1L0 4.56217Z",
    fill: "#763E1A",
    stroke: "#763E1A",
    strokeWidth: 0.178465,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M22.1655 12.0794L17.2399 10.6517L18.7247 12.8861L16.5117 17.205L19.4386 17.1693H23.8145L22.1655 12.0794ZM6.76039 10.6446L1.83475 12.0794L0.192871 17.1693H4.56884L7.49567 17.205L5.2827 12.8861L6.76753 10.6446H6.76039ZM13.435 13.1288L13.7562 7.70348L15.1839 3.84863H8.81631L10.244 7.70348L10.5653 13.1288L10.6866 14.8278V19.0396H13.3065L13.3208 14.8278L13.435 13.1288Z",
    fill: "#F5841F",
    stroke: "#F5841F",
    strokeWidth: 0.178465,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMetamask);
export default __webpack_public_path__ + "static/media/icon-metamask.f070fdbbaf520076cbd70c1ffa29b635.svg";
export { ForwardRef as ReactComponent };